import React from "react";
import styles from "./cv-new.module.scss";
import profilePic from "../../assets/profilepic.jpeg";

interface Job {
  title: string;
  period: string;
  company: string;
  location: string;
  points: string[];
}

const jobs: Job[] = [
  {
    title: "Fullstack Engineer",
    period: "Feb 2023 – Present",
    company: "Interhyp Gruppe",
    location: "München",
    points: [
      "Comparison portal for real estate trading",
      '"Home" as new portal in the future',
      "Cloud based network of ~100 microservices",
    ],
  },
  {
    title: "Fullstack Developer",
    period: "Jun 2021 – Dec 2022",
    company: "SprintEins GmbH",
    location: "München",
    points: [
      "Emission certification process tool for Mercedes-Benz",
      'Assisting from certification inquiry to .doc-export to the "KBA"',
      "Non-profit projects in cooperation with Caritas",
    ],
  },
  {
    title: "Software Developer",
    period: "Jun 2019 – Dec 2020",
    company: "Juconn GmbH",
    location: "Unterföhring",
    points: [
      "IoT sensor data processing and visualizing",
      "Automatic generated reports",
      "Microservices in NestJS / TypeScript",
    ],
  },
  {
    title: "Software Developer",
    period: "Mar 2019 – Jun 2019",
    company: "Wunderlabs UG",
    location: "Hallbergmoos",
    points: [
      "Responsive websites with mobile-first architecture",
      "Backends with Python-based CRMs",
    ],
  },
  {
    title: "Software Developer",
    period: "Jun 2018 – Feb 2019",
    company: "Artus Management GmbH",
    location: "Kulmbach",
    points: ["Automated arbitrage trading with crypto currencies"],
  },
];

const techStack = [
  "TypeScript",
  "JavaScript",
  "React",
  "Node.js",
  "NestJS",
  "Redux",
  "TypeORM",
  "Go",
  "Java",
  "Docker",
  "Kubernetes",
  "PostgreSQL",
  "MongoDB",
  "MySQL",
];

const softSkills = ["Inventiveness", "Ambitious", "Teamplayer", "Cooking"];
const certificates = ["French DELF A1", "Brandschutzhelfer (Oct 2022)"];

const CVNew: React.FC = () => {
  return (
    <main
      className={styles.page}
      itemScope
      itemType="https://schema.org/Person"
    >
      <meta itemProp="name" content="Maximilian Grätz" />
      <meta itemProp="jobTitle" content="Full-Stack Developer" />
      <meta itemProp="url" content="https://mgraetz.de" />

      {/* Hero */}
      <header className={styles.hero}>
        <div className={styles.photo}>
          <img
            src={profilePic}
            alt="Maximilian Grätz — Software Engineer Munich"
            itemProp="image"
          />
        </div>
        <div className={styles.heroInfo}>
          <h1 className={styles.heroName}>Maximilian Grätz</h1>
          <p className={styles.heroSubtitle}>
            Fullstack Engineer · Munich Area
          </p>
          <div className={styles.heroContact}>
            <a href="mailto:max@mgraetz.de" itemProp="email">
              max@mgraetz.de
            </a>
            <a
              href="https://www.linkedin.com/in/kingrio/"
              className={styles.linkedIn}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn Profile"
            >
              <svg
                viewBox="0 0 24 24"
                fill="currentColor"
                width="18"
                height="18"
              >
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>
      </header>

      {/* Experience */}
      <section>
        <h2 className={styles.sectionTitle}>Professional Experience</h2>
        <div className={styles.cardGrid}>
          {jobs.map((job, i) => (
            <article className={styles.card} key={i}>
              <h3 className={styles.cardTitle}>{job.title}</h3>
              <div className={styles.cardMeta}>{job.period}</div>
              <div className={styles.cardCompany}>
                {job.company}, {job.location}
              </div>
              <ul className={styles.cardPoints}>
                {job.points.map((point, j) => (
                  <li key={j}>{point}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      {/* Bottom row */}
      <div className={styles.bottomRow}>
        <section className={styles.bottomCard}>
          <h2 className={styles.sectionTitle}>Tech Stack</h2>
          <div className={styles.tags}>
            {techStack.map((t) => (
              <span className={styles.tag} key={t}>
                {t}
              </span>
            ))}
          </div>
        </section>

        <section className={styles.bottomCard}>
          <h2 className={styles.sectionTitle}>Education</h2>
          <h3 className={styles.eduSchool}>FH Rosenheim</h3>
          <div className={styles.eduPeriod}>Oct 2014 – Jun 2018</div>
          <ul className={styles.plainList}>
            <li>3 Semester "Wirtschaftsinformatik"</li>
            <li>4 Semester "Informatik"</li>
          </ul>
        </section>

        <section className={styles.bottomCard}>
          <h2 className={styles.sectionTitle}>Certificates</h2>
          <ul className={styles.plainList}>
            {certificates.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>

          <h2 className={styles.sectionTitle} style={{ marginTop: 20 }}>
            Soft Skills
          </h2>
          <ul className={styles.plainList}>
            {softSkills.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </section>
      </div>
    </main>
  );
};

export default CVNew;
